// Matches the "applies to any product" incentive used by the performance service.
const ALL_PRODUCTS_OID = 'all.med';

export const getAddableValueCases = ({ valueCases, referralDetails, performanceEntries } = {}) => {
    const existingValueCaseIds = (performanceEntries ?? []).map((entry) => entry.value_case_id);
    return (valueCases ?? []).filter(
        ({ segmentId, productServiceOids, valueCaseId }) =>
            segmentId === referralDetails?.segmentId &&
            (productServiceOids ?? []).some(
                (oid) => oid === referralDetails?.productServiceOid || oid === ALL_PRODUCTS_OID,
            ) &&
            !existingValueCaseIds.includes(valueCaseId),
    );
};
